import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import axios from 'axios';
import Swal from 'sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import es from "date-fns/locale/es";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
registerLocale('es', es);

const AddPrices = () => {
    const pricesTemplate = {
        origin_id: 0,
        destination_id: 0,
        date_init: "",
        date_finish: "",
        price: 0,
        price_pet: 0,
        price_extra: 0
    };
    const navigate = useNavigate();
    const [prices, setPrices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [origins, setOrigins] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getAllOrigins();
        getAllDestinations(0);
        var table = $('.main').DataTable();
        table.destroy();
        setTimeout(() => {
            $('.main').DataTable({
                searching: false,
                destroy: true,
                retrieve: true,
                pageLength: 1000,
                responsive: true,
                autoWidth: true,
                paging: false,
                ordering: true,
                sortable: true,
                processing: false,
                serverSide: false,
                bInfo: false,
                language: {
                    "decimal": "",
                    "emptyTable": "",
                    "info": "Mostrando _START_ a _END_ de _TOTAL_ registros",
                    "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "infoFiltered": "(filtrado de un total de _MAX_ registros)",
                    "infoPostFix": "",
                    "thousands": ",",
                    "lengthMenu": "Mostrar _MENU_ registros",
                    "loadingRecords": "Cargando...",
                    "processing": "Procesando...",
                    "search": "Buscar:",
                    "paginate": {
                        "first": "<i class='fa-solid fa-circle-chevron-left'></i>",
                        "last": "<i class='fa-solid fa-circle-chevron-right'></i>",
                        "next": "<i class='fas fa-arrow-circle-right'></i>",
                        "previous": "<i class='fas fa-arrow-circle-left'></i>"
                    },
                    "zeroRecords": "No hay registros",
                    "searchPlaceholder": "Buscar...",
                },
            });
            setLoading(false);
        }, 100);
    }, []);

    const onChange = (e, index) => {
        const updatePrices = prices.map((price, i) =>
            index === i ? Object.assign(price, { [e.target.name]: e.target.value }) : price
        );
        setPrices(updatePrices);
    };

    const handleAdd = () => {
        const newdata = [...prices];
        newdata.push(pricesTemplate);
        setPrices(newdata);
    };

    const handleRemove = (index) => {
        const newdata = [...prices];
        newdata.splice(index, 1);
        setPrices(newdata);
    };

    const getAllOrigins = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-origins-prices');
        const originsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setOrigins(originsArray);
    };

    const getAllDestinations = async (origin_id) => {
        setDestinations([]);
        setLoading(true);
        const response = await axios.get(ENDPOINT + 'get-all-destinations-prices/' + origin_id);
        const destinationsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setDestinations(destinationsArray);
        setLoading(false);
    };

    const handleSubmit = async () => {
        if (prices.length === 0) {
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">Debe agregar al menos un registro de precio</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            return;
        }
        const form = new FormData();
        const dataForm = JSON.stringify(prices);
        form.append('data', dataForm);
        setLoading(true);
        await axios.post(ENDPOINT + 'save-price', form).then(response => {
            setLoading(false);
            setPrices([]);
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
            navigate('/precios');
        }).catch(function (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            })
        });
    };

    const resetPage = () => {
        setLoading(true);
        window.location.reload(); 
    };

    return (
        <div>
            {loading && <Loader />}
            <div className="container-fluid">
                <ContentHeader title="Módulo de Precios" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications-header row">
                            <div className="col-md-7">
                                <h4 className="card-title m-0 page-title">
                                <i className="bi bi-tags me-2"></i> Agregar Precios
                                </h4>
                            </div>
                            <div className="col-md-5" style={{ textAlign: "right" }}>
                                <Link
                                    to="/precios"
                                    type="buttom"
                                    className="btn btn-secondary btn-sm me-1">
                                    <i className="fa-solid fa-list me-1"></i> Listado de Precios
                                </Link>
                                <button
                                    onClick={resetPage}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="indications row align-items-center">
                            <div className="col-lg-7">
                                <div className="add-trips-card search-controls bg-light p-4 rounded-3 shadow-sm h-100">
                                    <div className="add-trips-card-body">
                                        <div className="mb-4">
                                            <h6 className="text-muted mb-3">
                                                <i className="fas fa-money-bill-wave me-2"></i>
                                                Configure los registros de precios para los diferentes destinos y establezca tarifas específicas para cada ruta
                                            </h6>
                                        </div>
                                        <div className="row align-items-center mb-3">
                                            <div className="col-md-7">
                                                <p className="text-muted small mb-0">
                                                    <i className="fas fa-plus-circle me-1"></i>
                                                    Agregue una nueva fila para configurar precios adicionales por ruta, fecha y tipo de tarifa
                                                </p>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="d-grid">
                                                    <button
                                                        id="addPrice"
                                                        onClick={handleAdd}
                                                        type="button"
                                                        className="btn btn-primary btn-sm d-flex align-items-center justify-content-center py-2">
                                                        <i className="fa-solid fa-square-plus me-2"></i> Agregar nuevo registro
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row align-items-center">
                                            <div className="col-md-7">
                                                <p className="text-muted small mb-0">
                                                    <i className="fas fa-save me-1"></i>
                                                    Guarde todos los registros de precios configurados en el sistema
                                                </p>
                                            </div>
                                            <div className="col-md-5">
                                                <div className="d-grid">
                                                    <button
                                                        onClick={handleSubmit}
                                                        className="btn btn-success btn-sm d-flex align-items-center justify-content-center py-2">
                                                        <i className="fa-solid fa-floppy-disk me-2"></i> Guardar Precios
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="add-trips-summary h-100 text-white p-4 rounded-3 shadow position-relative overflow-hidden">
                                    <div className="add-trips-card-body position-relative z-1">
                                        <h6 className="text-white-50 mb-3">Total de registros de precios</h6>
                                        <h2 className="display-4 fw-bold mb-0">
                                            {prices.length}
                                        </h2>
                                        <p className="mb-0 mt-2 text-white-50">
                                            {prices.length === 0 ? (
                                                <><i className="fas fa-info-circle me-1"></i> No hay registros configurados</>
                                            ) : (
                                                <><i className="fas fa-tags me-1"></i> Precios configurados</>
                                            )}
                                        </p>
                                    </div>
                                    <div className="position-absolute bottom-0 end-0 p-4 opacity-25">
                                        <i className="fas fa-dollar-sign" style={{ fontSize: '5rem' }}></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-2">
                            <table className="table table-hover table-striped">
                                <thead>
                                    <tr>
                                        <th width="10%" className="text-center">Origen</th>
                                        <th width="10%" className="text-center">Destino</th>
                                        <th width="10%" className="text-center">Fecha Inicial</th>
                                        <th width="10%" className="text-center">Fecha Final</th>
                                        <th width="10%" className="text-center">Precio</th>
                                        <th width="10%" className="text-center">Precio Mascota</th>
                                        <th width="10%" className="text-center">Precio Extra</th>
                                        <th width="10%" className="text-center">Opción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {prices.map((value, index) =>
                                        <tr key={index}>
                                            <td>
                                                <select
                                                    style={{ marginTop: "8px" }}
                                                    className="form-control form-control-sm select2 trip"
                                                    id="origin_id"
                                                    name="origin_id"
                                                    data-index={index}
                                                    onChange={(e) => onChange(e, index)}
                                                >
                                                    <option selected value="0">Seleccione</option>
                                                    {origins.map((item, index) => (
                                                        <option key={index} value={item.value}>{item.label}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td>
                                                <select
                                                    style={{ marginTop: "8px" }}
                                                    className="form-control form-control-sm select2 trip"
                                                    id="destination_id"
                                                    name="destination_id"
                                                    data-index={index}
                                                    onChange={(e) => onChange(e, index)}
                                                >
                                                    <option selected value="0">Seleccione</option>
                                                    {destinations.map((item, index) => (
                                                        <option key={index} value={item.value}>{item.label}</option>
                                                    ))}
                                                </select>
                                            </td>
                                            <td>
                                                <input
                                                    style={{ marginTop: "8px" }}
                                                    onChange={(e) => onChange(e, index)}
                                                    className={`form-control form-control-sm trip`}
                                                    placeholder="Fecha Inicio"
                                                    type="date"
                                                    id="date_init"
                                                    name="date_init"
                                                    required
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    style={{ marginTop: "8px" }}
                                                    onChange={(e) => onChange(e, index)}
                                                    className={`form-control form-control-sm trip`}
                                                    placeholder="Fecha Final"
                                                    type="date"
                                                    id="date_finish"
                                                    name="date_finish"
                                                    required
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    style={{ marginTop: "8px" }}
                                                    onChange={(e) => onChange(e, index)}
                                                    className={`form-control form-control-sm trip`}
                                                    placeholder="Precio"
                                                    type="number"
                                                    id="price"
                                                    name="price"
                                                    required
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    style={{ marginTop: "8px" }}
                                                    onChange={(e) => onChange(e, index)}
                                                    className={`form-control form-control-sm trip`}
                                                    placeholder="Precio Mascota"
                                                    type="number"
                                                    id="price_pet"
                                                    name="price_pet"
                                                    required
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    style={{ marginTop: "8px" }}
                                                    onChange={(e) => onChange(e, index)}
                                                    className={`form-control form-control-sm trip`}
                                                    placeholder="Precio Extra"
                                                    type="number"
                                                    id="price_extra"
                                                    name="price_extra"
                                                    required
                                                />
                                            </td>
                                            <td className="text-center">
                                                <button
                                                    style={{ marginTop: "6px" }}
                                                    onClick={handleRemove}
                                                    type="buttom"
                                                    className="btn btn-xs btn-danger">
                                                    <i className="fa-solid fa-trash me-2"></i>
                                                    Remover
                                                </button>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPrices;